import i18n from 'i18next';
import type {FC} from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {useAsync} from 'react-use';
import {isTokenValidUseCase} from '@/compositionRoot';

const PrivateRoute: FC = () => {
  const isTokenValid = useAsync(isTokenValidUseCase.execute, []);

  return isTokenValid.loading ? (
    <div>Loading...</div>
  ) : isTokenValid.value ? (
    <Outlet />
  ) : (
    <Navigate to={`/${i18n.resolvedLanguage}/login`} />
  );
};

export default PrivateRoute;
